// 1==> import external libraries
import React, { useEffect, useState } from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Breadcrumbs,
  Button,
  Card,
  Link,
  Paper,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputBase,
  IconButton,
  Grid,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";

//2==> import internal component and modules

import { dateFormatStartFun } from "../../helper/dateConverter";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";

//3==> import styles and css
import { useStyles } from "../../theme/theme";

import { DatePicker } from "@mui/x-date-pickers";

import { pendingEarningTransactionAction } from "../../redux/toolkit/pendingEarning/pendingEarning";
import ClearPending from "./ClearPending";
import { tr } from "date-fns/locale";
import { render } from "@testing-library/react";
import { getAllAppAction } from "../../redux/toolkit/app/getAllApp";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="pendingTransaction"
      >
        Pending Transaction
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Pending Transaction
    </Typography>
  </Stack>
);

const PendingEarning = () => {
  const dispatch = useDispatch();
  const [transactionId, setTransactionId] = useState("");

  const [state, setState] = useState(false);
  const [app, setApp] = useState("");
  const [userId, setUserId] = useState("");

  const getPendingTransaction = useSelector(
    (state) => state.pendingTranasction
  );

  const { data, loading, total, message, status } = getPendingTransaction;

  console.log("total pages=============================.", total);

  // const blockAndUnBlockAdminSelector = useSelector(state => state.blockAndUnBlockAdmin)
  // const { status, message } = blockAndUnBlockAdminSelector
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const [snack, setSnack] = useState(false);
  const classes = useStyles();
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const partnerDetails = useSelector((state) => state.allPartnerWithoutLimit);

  const [isPending, setIsPending] = useState("true");
  const appsData = useSelector((state) => state.appAllList);
  const { data: app_data } = appsData;
  const [partner, setPartner] = useState("");

  const adminColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    // {
    //     field: '_id',
    //     headerName: 'ID',
    //     flex: 1,
    //     headerClassName: 'super-app-theme--header',
    //     minWidth: 220,
    // },
    {
      field: "publisher_id",
      headerName: "Publisher Name",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 220,
     renderCell: (params) => {
        return <Typography>{params?.row?.publisher_id?.name}</Typography>;
      },
    },
    {
      field: "app_id",
      headerName: "App",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 250,
       renderCell: (params) => {
        return <Typography>{params?.row?.app_id?.app_name}</Typography>;
      },
    },
    
    {
      field: "user_id",
      headerName: "User ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.user_id?._id}</Typography>;
      },
    },

    {
      field: "user_email",
      headerName: "User Email",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.user_id?.email}</Typography>;
      },
    },

    // {
    //   field: "trans_id",
    //   headerName: "Trans ID",
    //   flex: 1,
    //   minWidth: 250,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     return <Typography>{<spa>{params?.row?.trans_id.splice(0, 5)}</spa>}</Typography>;
    //   },
    // },
    {
      field: "trans_id",
      headerName: "Trans ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography component="div">
            <div
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                lineHeight: 1.4,
                width: "100%",
              }}
            >
              {params?.row?.trans_id}
            </div>
          </Typography>
        );
      },
    },

    {
      field: "partner_id.name",
      headerName: "Partner Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.partner_id?.name}</Typography>;
      },
    },

    {
      field: "isPending",
      headerName: "Is Pending",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      // renderCell: (params) => {
      //     return (
      //         <Typography>{params?.row?.user_id}</Typography>
      //     )
      // },
    },

    {
      field: "publisher_payout",
      headerName: "Publisher Payout",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 180,
    },

    {
      field: "user_payout",
      headerName: "User Payout",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
    },

    {
      field: "bonus_amt",
      headerName: "Bonus Amount",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
    },

    {
      field: "raw_amount",
      headerName: "Raw Amount",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Typography>
            {params?.row?.status == 0
              ? "Pending"
              : params?.row?.status == 1
              ? "Success"
              : "Failed"}
          </Typography>
        );
      },
    },

    {
      field: "clearPending",
      headerName: "Clear Pending",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,

      renderCell: (params) => {
        return params?.row?.isPending ? (
          <Button
            variant="contained"
            onClick={() => {
              setState(true);
              setTransactionId(params?.row?._id);
            }}
          >
            Clear Pending
          </Button>
        ) : (
          "---"
        );
      },
    },

    {
      field: "created_at",
      headerName: "Created",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 230,
      renderCell: (params) => {
        return (
          <Typography>
            {moment(params?.row?.createdAt).format("YYYY-MM-DD hh:mm:ss A")}
          </Typography>
        );
      },
    },

    {
      field: "cleared_at",
      headerName: "Cleared At By Admin",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 230,
      renderCell: (params) => {
        return (
          <Typography>
            {params?.row?.cleared_at
              ? moment(params?.row?.cleared_at).format("YYYY-MM-DD hh:mm:ss A")
              : "---"}
          </Typography>
        );
      },
    },
  ];

  const dateWiseUser = () => {
    dispatch(
      pendingEarningTransactionAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate
          ? dateFormatStartFun(date?.startDate)
          : "undefined",
        endDate: date?.endDate
          ? dateFormatStartFun(date?.endDate)
          : "undefined",
        isPending: isPending,
        app: app,
        partner:partner
      })
    );
  };

  const searchHandler = () => {
    dispatch(
      pendingEarningTransactionAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate
          ? dateFormatStartFun(date?.startDate)
          : "undefined",
        endDate: date?.endDate
          ? dateFormatStartFun(date?.endDate)
          : "undefined",
        isPending: isPending,
        app: app,
        userId: userId,
        partner:partner
      })
    );
  };

  const handleChange = (event) => {
    setIsPending(event.target.value);
  };
  const handlePartnerChange = (event) => {
    setPartner(event.target.value);
  };

  useEffect(() => {
    dispatch(getAllPartnerActionNoLimit({}));
  }, []);

  // useEffect
  useEffect(() => {
    dispatch(
      pendingEarningTransactionAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: "undefined",
        endDate: "undefined",
        isPending: isPending,
        app: "undefined",
        partner:partner
      })
    );
  }, [dispatch, pageState.page, pageState.pageSize]);

  useEffect(() => {
    dispatch(getAllAppAction({}));
  }, []);

  return (
    <>
      <Helmet>
        <title>Real Opinion Admin | Charge Back</title>
      </Helmet>

      <Appbar breadcrumb={breadcrumb} />
      {/* <DrawerUI /> */}
      <Body>
        <Stack
          sx={{ mb: 1 }}
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Paper
              component="form"
              sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: 400,
                backgroundColor: "transparent",
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search By UserId"
                inputProps={{
                  "aria-label": "Search By UserId",
                }}
                onChange={(e) => setUserId(e.target.value)}
              />
              <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon onClick={searchHandler} />
              </IconButton>
            </Paper>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          spacing={2}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Min Data"
              value={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, startDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Max Data"
              value={date?.endDate}
              minDate={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, endDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Is Pending</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={isPending}
                label="Is Pending"
                onChange={handleChange}
              >
                <MenuItem value={"true"}>Pending</MenuItem>
                <MenuItem value={"false"}>Clear</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Stack direction="row">
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Apps</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Publisher"
                  onChange={(event) => {
                    setApp(event.target.value);
                  }}
                >
                  {app_data?.map((item, i) => (
                    <MenuItem value={item._id}>{item.app_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>

          <Stack direction="row">
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select Partner
                </InputLabel>

                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={partner}
                  label="Select Partner"
                  onChange={handlePartnerChange}
                >
                  {partnerDetails?.data?.map((item) => {
                    return <MenuItem value={item._id}>{item.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Box>
          </Stack>

          {((date.startDate && date.endDate) || app || partner) && (
            <Button variant="contained" onClick={dateWiseUser}>
              find data
            </Button>
          )}
        </Stack>

        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={adminColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              // pageSize={pageSize}
              // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              // onCellClick={(params) => {
              //     setadmin_id(params?.row?._id)
              // }}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                // Toolbar: GridToolbar,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>

        {/* modals */}
      </Body>

      {state && (
        <ClearPending
          state={state}
          setState={setState}
          trans_id={transactionId}
          isPending={isPending}
        />
      )}

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default PendingEarning;
